import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('Person')

export default {
  label: 'Person',
  route: 'person',
  fields: [
    Filter.ReferenceByMultiValueSearchRep('organisationseinheiten', 'sitemap', 'organisationseinheit'),
    Filter.kumuliert(),
    Filter.String('titel'),
    Filter.String('vorname'),
    Filter.String('name'),
    Filter.String('fisPersid'),
    Filter.String('personIdentWert')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/PersonFilter.js